import oddsCheckerBetslip from './oddsCheckerBetslip';
import { has } from 'utils/features';

export default (config) => {
    if (!global.window) {
        return [];
    }

    if (has("integrated-betslip") && has('oddschecker-betslip')) {
      return [
        ...oddsCheckerBetslip(global.window, config)
      ];
    }

    return [];
};



// WEBPACK FOOTER //
// ./modules/Common/middleware/betslipMiddlewareFactory.js